import React from 'react';
import { AppRoutes } from "../../routes/AppRoutes";

const Body = () => {
    return (
        <main className="flex-grow-1 bg-light p-1 overflow-auto">
            <div>
                <AppRoutes />
            </div>
        </main>
    );
};

export default Body;
